export const baseAnimation = {
  data() {
    return {
      containerAnimationClass: '',
      timeout: null
    }
  },
  methods: {
    resetContainerAnimation() {
      this.timeout = setTimeout(() => {
        this.containerAnimationClass = '';
      }, 400);
    },
    setAnimationClass() {
      return;
      // temp disabling
      // clearTimeout(this.timeout);
      // switch (this.item.userBidStatus.status) {
      //   case this.bidStatuses.high:
      //     this.containerAnimationClass = 'refresh-win';
      //     break;
      //   case this.bidStatuses.outbid:
      //     this.containerAnimationClass = 'refresh-lose';
      //     break;
      //   default:
      //     this.containerAnimationClass = 'refresh-watch';
      //     break;
      // }

      // this.resetContainerAnimation();
    },
  }
}